import { useEffect, useMemo, useState } from "react"
import { GD } from "src/GD"
import { buildBuyerCardFinancials } from "src/utils/buyerFinancials"
import { optionalRequest } from "src/utils/optionalRequest"
import { useOptionalIssuer } from "src/view/issuer/IssuerProvider"

export const useBuyerFinancials = () => {
	const [cards, setCards] = useState<ICardSaved[]>()
	const selectedIssuerId = useOptionalIssuer()?.selectedIssuerId ?? null

	useEffect(() => {
		let disposed = false
		setCards(undefined)
		const load = async () => {
			const cardsResponse = await optionalRequest(() => GD.REQ_CARDS.request())
			if (disposed) return
			if (cardsResponse?.data) {
				setCards(cardsResponse.data)
			}
		}

		void load()
		return () => {
			disposed = true
		}
	}, [selectedIssuerId])

	return {
		cards,
		cardFinancials: useMemo(() => buildBuyerCardFinancials(cards), [cards])
	}
}
